export const FUN_DATA = {
  sysDateUtil: {
    addDays: '_this.util.addDays',
    dateDiff: '_this.util.dateDiff',
    hourDiff: '_this.util.hourDiff',
    getLeaveDates: '_this.util.getLeaveDates',
    getLeaveHours: '_this.util.getLeaveHours'
  }
}

export const funUtil = {
  replaceStr (type, str) {
    let funs = FUN_DATA[type]
    if (funs) {
      for (let fun in funs) {
        str = str.replace(type + '.' + fun, funs[fun])
      }
    }
    return str
  }
}



// WEBPACK FOOTER //
// ./src/common/form/util.js